<template>
  <div
    ref="kt_modal_pedido_pagamento_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_pedido_pagamento_editar"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/finance/fin010.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Pagamento</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelarPagamento()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body pt-6 pb-2 px-6">
          <div class="row">
            <div class="col-12 col-lg-7 fv-row mb-6">
              <div class="row">
                <div
                  class="col-1 fv-row d-flex justify-content-end align-items-end p-0 mb-3"
                >
                  <span class="svg-icon svg-icon-2qx"
                    ><inline-svg
                      :src="getEspeciePagamento(pagamento.cod_especie)"
                  /></span>
                </div>
                <div class="col-11 fv-row">
                  <label class="form-label required fw-bold fs-6"
                    >Espécie</label
                  >
                  <select
                    class="form-select"
                    v-model="this.pagamento.descricao"
                    @change="atualizarEspeciePagamento($event.target.value)"
                  >
                    <option
                      v-for="forma in formasPagamento"
                      v-bind:key="forma.descricao"
                      v-bind:value="forma.descricao"
                    >
                      {{ forma.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-5 mb-2">
              <div class="mb-6 fv-row">
                <label class="required form-label">Valor Pagamento</label>
                <CurrencyInput
                  id="txtValorPagamento"
                  class="form-control mb-2"
                  placeholder="Valor Pagamento"
                  style="text-align: right"
                  v-model="this.pagamento.valor_recebido"
                  :options="options"
                ></CurrencyInput>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["valor_recebido"] }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6 fv-row mb-6">
              <label class="form-label fw-bold fs-6">Tipo</label>
              <select class="form-select" v-model="this.pagamento.tipo">
                <option value=""></option>
                <option value="ONLINE">ONLINE</option>
                <option value="PAGAMENTO NA ENTREGA">
                  PAGAMENTO NA ENTREGA
                </option>
                <option value="PRÉ-DATADO">PRÉ-DATADO</option>
                <option value="OUTRO">OUTRO</option>
              </select>
            </div>
            <div class="col-12 col-lg-6 mb-2">
              <div class="mb-6 fv-row">
                <label for="txtEmissor" class="form-label">Emissor</label>
                <input
                  type="text"
                  id="txtEmissor"
                  class="form-control"
                  v-model="this.pagamento.emissor"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-5 mb-2">
              <div class="mb-6 fv-row">
                <label class="form-label">Troco para</label>
                <CurrencyInput
                  class="form-control mb-2 text-primary"
                  placeholder="Troco para"
                  style="text-align: right"
                  v-model="this.pagamento.troco_entrega"
                  :options="options"
                ></CurrencyInput>
              </div>
            </div>
            <div
              class="col-12 col-lg-7 mb-6 d-flex align-items-center justify-content-lg-center"
            >
              <div class="fv-row">
                <label class="form-label me-5">Status</label>
                <div class="btn-group">
                  <label
                    class="btn text-muted text-hover-white text-active-white btn-outline btn-active-danger"
                    :class="[this.pagamento.pendente === '1' && 'active']"
                  >
                    <input
                      class="btn-check"
                      type="radio"
                      @click="this.pagamento.pendente = '1'"
                    />
                    Pendente
                  </label>
                  <label
                    class="btn text-muted text-hover-white text-active-white btn-outline btn-active-success"
                    :class="[this.pagamento.pendente === '0' && 'active']"
                  >
                    <input
                      class="btn-check"
                      type="radio"
                      @click="this.pagamento.pendente = '0'"
                    />
                    Aprovado
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelarPagamento()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmarPagamento()"
            v-bind:data-kt-indicator="this.loadingPagamento ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loadingPagamento">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CurrencyInput from "@/components/text/CurrencyInput";
import { hideModal } from "@/core/helpers/dom";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: [
    "exibirModalPedidoPagamento",
    "adicionarPagamento",
    "editarPagamento",
  ],
  components: { CurrencyInput },
  props: {
    index: { type: Number, required: true, default: -1 },
    pedido: { type: Object, required: true },
  },
  methods: {
    confirmarPagamento() {
      this.errosValidacao = [];
      this.loadingPagamento = true;
      if (
        this.pagamento.valor_recebido === 0 ||
        this.pagamento.valor_recebido === null
      ) {
        this.errosValidacao = {
          valor_recebido: "O valor do pagamento não pode estar zerado!",
        };
        toast.error("O valor do pagamento não pode estar zerado!", {
          timeout: 3000,
        });
      } else {
        this.pagamento.valor = this.pagamento.valor_recebido;
        if (this.index === -1) {
          this.$emit("adicionarPagamento", this.pagamento);
        } else {
          this.$emit("editarPagamento");
        }
        hideModal(this.$refs.kt_modal_pedido_pagamento_editar);
        this.$emit("exibirModalPedidoPagamento", false);
      }
      this.loadingPagamento = false;
    },
    cancelarPagamento() {
      if (this.index === -1) {
        toast.error("Inclusão do pagamento cancelada!", { timeout: 2000 });
      } else {
        this.pagamento.cod_especie = this.pagamentoInicial.cod_especie;
        this.pagamento.descricao = this.pagamentoInicial.descricao;
        this.pagamento.valor = this.pagamentoInicial.valor;
        this.pagamento.valor_recebido = this.pagamentoInicial.valor_recebido;
        this.pagamento.troco_entrega = this.pagamentoInicial.troco_entrega;
        this.pagamento.emissor = this.pagamentoInicial.emissor;
        this.pagamento.tipo = this.pagamentoInicial.tipo;
        this.pagamento.pendente = this.pagamentoInicial.pendente;
        toast.error("Alteração do pagamento cancelada!", { timeout: 2000 });
      }
      hideModal(this.$refs.kt_modal_pedido_pagamento_editar);
      this.$emit("exibirModalPedidoPagamento", false);
    },
    atualizarEspeciePagamento(descricao) {
      this.formasPagamento.find((element) => {
        if (element.descricao === descricao) {
          this.pagamento.cod_especie = element.cod_especie;
        }
      });
    },
    getEspeciePagamento(cod_especie) {
      for (var i = 0; i < this.formasPagamento.length; i++) {
        if (this.formasPagamento[i].cod_especie === cod_especie) {
          return this.formasPagamento[i].icon;
        }
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  mounted() {
    if (this.index === -1) {
      this.pagamentoInicial = null;
      this.pagamento = {
        id: 0,
        id_pedido: 0,
        cod_especie: "1",
        descricao: "Dinheiro",
        valor: 0,
        valor_recebido: 0,
        troco_entrega: 0,
        emissor: "",
        tipo: "",
        pendente: "0",
      };
    } else {
      this.pagamentoInicial = JSON.parse(
        JSON.stringify(this.pedido.PedidoPagamento[this.index])
      );
      this.pagamento = this.pedido.PedidoPagamento[this.index];
    }
    this.errosValidacao = [];
    this.$utils.requestFocus("txtValorPagamento");
  },
  data() {
    return {
      errosValidacao: [],
      loadingPagamento: false,
      pagamentoInicial: null,
      pagamento: {
        id: 0,
        id_pedido: 0,
        cod_especie: "1",
        descricao: "Dinheiro",
        valor: 0,
        valor_recebido: 0,
        troco_entrega: 0,
        emissor: "",
        tipo: "",
        pendente: "1",
      },
      formasPagamento: [
        {
          cod_especie: "1",
          descricao: "Dinheiro",
          icon: "media/icons/duotune/finance/fin003.svg",
        },
        {
          cod_especie: "2",
          descricao: "Cheque",
          icon: "media/icons/duotune/files/fil003.svg",
        },
        {
          cod_especie: "3",
          descricao: "Cartão de Crédito",
          icon: "media/icons/duotune/finance/fin002.svg",
        },
        {
          cod_especie: "4",
          descricao: "Cartão de Débito",
          icon: "media/icons/duotune/finance/fin002.svg",
        },
        {
          cod_especie: "5",
          descricao: "Crédito Loja",
          icon: "media/icons/duotune/coding/cod002.svg",
        },
        {
          cod_especie: "5",
          descricao: "A PRAZO",
          icon: "media/icons/duotune/coding/cod002.svg",
        },
        {
          cod_especie: "5",
          descricao: "Convênio",
          icon: "media/icons/duotune/coding/cod002.svg",
        },
        {
          cod_especie: "5",
          descricao: "T.E.F",
          icon: "media/icons/duotune/coding/cod002.svg",
        },
        {
          cod_especie: "10",
          descricao: "Vale Alimentação",
          icon: "media/icons/duotune/ecommerce/ecm011.svg",
        },
        {
          cod_especie: "11",
          descricao: "Vale Refeição",
          icon: "media/icons/duotune/ecommerce/ecm011.svg",
        },
        {
          cod_especie: "12",
          descricao: "Vale Presente",
          icon: "media/icons/duotune/ecommerce/ecm011.svg",
        },
        {
          cod_especie: "13",
          descricao: "Vale Combustível",
          icon: "media/icons/duotune/ecommerce/ecm011.svg",
        },
        {
          cod_especie: "17",
          descricao: "PIX",
          icon: "media/icons/duotune/finance/fin010.svg",
        },
        {
          cod_especie: "99",
          descricao: "Outros",
          icon: "media/icons/duotune/finance/fin008.svg",
        },
      ],
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style></style>
